import i18next from 'i18next';

const MAX_SIDE_PX = 1600;
const JPEG_QUALITY = 0.8;
const JPEG_MIME = 'image/jpeg';
const MATTE = '#FFFFFF';

const photoError = () => new Error(i18next.t('chat.photo_error'));

const loadImage = (blob) =>
	new Promise((resolve, reject) => {
		const url = URL.createObjectURL(blob);
		const image = new Image();
		image.onload = () => {
			URL.revokeObjectURL(url);
			resolve(image);
		};
		image.onerror = () => {
			URL.revokeObjectURL(url);
			reject(photoError());
		};
		image.src = url;
	});

export const resizeImage = async (blob) => {
	if (!(blob instanceof Blob) || !blob.type.startsWith('image/')) {
		throw photoError();
	}
	const image = await loadImage(blob);
	const longest = Math.max(image.naturalWidth, image.naturalHeight);
	if (!longest) {
		throw photoError();
	}
	const scale = Math.min(1, MAX_SIDE_PX / longest);
	const width = Math.max(1, Math.round(image.naturalWidth * scale));
	const height = Math.max(1, Math.round(image.naturalHeight * scale));
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = height;
	const context = canvas.getContext('2d');
	if (!context) {
		throw photoError();
	}
	context.fillStyle = MATTE;
	context.fillRect(0, 0, width, height);
	context.drawImage(image, 0, 0, width, height);
	const dataUrl = canvas.toDataURL(JPEG_MIME, JPEG_QUALITY);
	if (!dataUrl.startsWith(`data:${JPEG_MIME};base64,`)) {
		throw photoError();
	}
	return { dataUrl, mime: JPEG_MIME, width, height };
};
